package com.evoapps.evoshift.viewmodels

import androidx.lifecycle.ViewModel
import com.evoapps.evoshift.observability.PrivacyConsent
import com.evoapps.evoshift.observability.TelemetryConsent
import kotlinx.coroutines.flow.StateFlow

/**
 * Crash reports and usage statistics (SH-86): the first-run question and the two switches in
 * Profile. The choice is stored on the device and applied at once (optimistic by nature: nothing
 * to wait for, nothing to roll back).
 */
class PrivacyChoicesViewModel(private val consent: PrivacyConsent) : ViewModel() {
    val state: StateFlow<TelemetryConsent> = consent.consent

    /** Crashlytics has no web SDK: there the crash-report switch is not offered. */
    val offersCrashReports: Boolean get() = consent.platform.supportsCrashReports

    val shouldAsk: Boolean get() = consent.shouldAsk

    /** "Allow selected": only what was ticked (nothing ticked is the same as "Not now"). */
    fun allowSelected(crashReports: Boolean, usageStats: Boolean) = consent.answer(crashReports, usageStats)

    fun notNow() = consent.answer(crashReports = false, usageStats = false)

    fun setCrashReports(enabled: Boolean) = consent.setCrashReports(enabled)

    fun setUsageStats(enabled: Boolean) = consent.setUsageStats(enabled)
}
